import { get } from "lodash";
import { Navigate, useRoutes } from "react-router-dom";
import { useAppSelector } from "../hooks/useSelector";
import DashboardLayout from "../layouts/Dashboard";
import MinimalLayout from "../layouts/Minimal";
import AccountProfilePage from "../pages/AccountProfilePage";
import ChangePasswordPage from "../pages/ChangePasswordPage";
import ForgotPage from "../pages/ForgotPage";
import LoadingPage from "../pages/LoadingPage";
import PageNotFound from "../pages/PageNotFound";
import PurchaseCreate from "../pages/purchase/PurchaseCreate";
import PurchaseDetail from "../pages/purchase/PurchaseDetail";
import PurchaseEdit from "../pages/purchase/PurchaseEdit";
import PurchaseList from "../pages/purchase/PurchaseList";
import PurchaseOrder from "../pages/purchase/PurchaseOrder";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import SignInPage from "../pages/SignInPage";
import UserCreate from "../pages/user/UserCreate";
import UserEdit from "../pages/user/UserEdit";
import UserList from "../pages/user/UserList";

export default function Routes() {
  const { user } = useAppSelector((state) => state.global);
  const chooseDefaultRoute: any = () => {
    const role = get(user, "role_id");
    if (user?.is_admin || role === 1) {
      return { element: <Navigate to="/app/purchase/order" />, index: true };
    } else if (role === 2) {
      return { element: <Navigate to="/app/purchase/order" />, index: true };
    }
    return { element: <LoadingPage />, index: true };
  };
  return useRoutes([
    {
      path: "/app",
      element: <DashboardLayout />,
      children: [
        {
          path: "/app",
          children: [chooseDefaultRoute()],
        },
        {
          path: "/app/profile",
          children: [
            { element: <AccountProfilePage />, index: true },
            {
              element: <ChangePasswordPage />,
              path: "/app/profile/change-password",
            },
          ],
        },
        {
          path: "/app/purchase",
          children: [
            { element: <PurchaseList />, index: true },
            {
              element: <PurchaseCreate />,
              path: "/app/purchase/create-purchase",
            },
            {
              element: <PurchaseEdit />,
              path: "/app/purchase/edit/:id",
            },
            {
              element: <PurchaseDetail />,
              path: "/app/purchase/detail/:id",
            },
            {
              element: <PurchaseOrder />,
              path: "/app/purchase/order",
            }
          ],
        },
        {
          path: "/app/users",
          children: [
            { element: <UserList />, index: true },
            {
              element: <UserCreate />,
              path: "/app/users/create-user",
            },
            {
              element: <UserEdit />,
              path: "/app/users/edit/:id",
            },
          ],
        },

        {
          path: "*",
          element: <PageNotFound fullWidth={false} />,
        },
      ],
    },
    {
      path: "/",
      element: <MinimalLayout />,
      children: [
        {
          path: "/",
          element: <SignInPage />,
        },
        {
          path: "/reset-password",
          element: <ForgotPage />,
        },
        {
          path: "/forgot-password/",
          element: <ResetPasswordPage />,
        },
        {
          path: "*",
          element: <PageNotFound fullWidth />,
        },
      ],
    },
  ]);
}
